// params = [{ key, param}]
export const addOrDeleteQueryParams = (location, params = []) => {
    const searchObj = Object.fromEntries(new URLSearchParams(location.search));
    params.forEach(pa => {
        const key = Object.keys(pa)[0];
        if (pa[key] === null) {
            delete searchObj[key];
        } else {
            searchObj[key] = pa[key];
        }
    });

    const newQuery = new URLSearchParams(searchObj).toString();
    return `?${newQuery}`;
};

export const getQueryValue = (location, queryKey) => {
    let value = null;
    const searchObj = Object.fromEntries(new URLSearchParams(location.search));
    if (searchObj[queryKey]) {
        value = searchObj[queryKey];
    }
    return value;
};